module.exports = __webpack_public_path__ + "img/c0d93024ea2ff84b8f1b86d23b57287f.png";